/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApplyPenaltyBody
 */
export interface ApplyPenaltyBody {
    /**
     * Penalty type. Must match the handler's validTypes exactly.
     * @type {string}
     * @memberof ApplyPenaltyBody
     */
    type: ApplyPenaltyBodyTypeEnum;
    /**
     * Amount for point or fuel deductions
     * @type {number}
     * @memberof ApplyPenaltyBody
     */
    amount?: number;
    /**
     * 
     * @type {string}
     * @memberof ApplyPenaltyBody
     */
    reason: string;
    /**
     * Optional match ID if penalty is match-specific
     * @type {string}
     * @memberof ApplyPenaltyBody
     */
    matchId?: string;
}


/**
 * @export
 */
export const ApplyPenaltyBodyTypeEnum = {
    warning: 'warning',
    point_deduction: 'point_deduction',
    fuel_deduction: 'fuel_deduction',
    suspension: 'suspension'
} as const;
export type ApplyPenaltyBodyTypeEnum = typeof ApplyPenaltyBodyTypeEnum[keyof typeof ApplyPenaltyBodyTypeEnum];


/**
 * Check if a given object implements the ApplyPenaltyBody interface.
 */
export function instanceOfApplyPenaltyBody(value: object): value is ApplyPenaltyBody {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('reason' in value) || value['reason'] === undefined) return false;
    return true;
}

export function ApplyPenaltyBodyFromJSON(json: any): ApplyPenaltyBody {
    return ApplyPenaltyBodyFromJSONTyped(json, false);
}

export function ApplyPenaltyBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApplyPenaltyBody {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'reason': json['reason'],
        'matchId': json['matchId'] == null ? undefined : json['matchId'],
    };
}

export function ApplyPenaltyBodyToJSON(json: any): ApplyPenaltyBody {
    return ApplyPenaltyBodyToJSONTyped(json, false);
}

export function ApplyPenaltyBodyToJSONTyped(value?: ApplyPenaltyBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'amount': value['amount'],
        'reason': value['reason'],
        'matchId': value['matchId'],
    };
}

